import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProductDepthLevelRfsActionsComponent } from '../product-depth-level-rfs-actions.component';

@Component({
  selector: 'app-installation-status',
  templateUrl: './installation-status.component.html',
  styleUrls: ['./installation-status.component.scss']
})
export class InstallationStatusComponent implements OnInit {

  info: any;

  constructor(public dialogRef: MatDialogRef<ProductDepthLevelRfsActionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.info = this.data;
  }

}
